import { Injectable } from '@angular/core';
import {  BehaviorSubject } from 'rxjs';
import OktaAuth from '@okta/okta-auth-js';
import { environment } from '@env';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  token: string;
  private authClient = new OktaAuth({
    issuer: environment.OKTA_ISSUER,
    clientId: environment.OKTA_CLIENT_ID
  });

  public isAuthenticated = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {}

  async checkAuthenticated() {
    const authenticated = await this.authClient.session.exists();
    this.authClient.session.get().then(session => {
      if (session.status === 'INACTIVE') {
        localStorage.removeItem('authUser');
        // this.logout('/auth/login');
      }
      const user = this.getUser();
      if (user) {
        user.expiresAt = session.expiresAt;
        localStorage.setItem('authUser', JSON.stringify(user));
      }
    });
    this.isAuthenticated.next(authenticated);
    return authenticated;
  }

  async login(username: string, password: string) {
    const transaction = await this.authClient.signIn({ username, password });

    if (transaction.status !== 'SUCCESS') {
      throw Error(
        'We cannot handle the ' +
          transaction.status +
          ' status. Could be Invalid username or password'
      );
    } else {
      localStorage.setItem(
        'authUser',
        JSON.stringify({
          id: transaction.user.id,
          profile: transaction.user.profile,
          expiresAt: transaction.expiresAt,
          sessionToken: transaction.sessionToken
          })
      );
    }
    this.isAuthenticated.next(true);

    this.authClient.session.setCookieAndRedirect(transaction.sessionToken);
  }

  async logout(redirect: string) {
    try {
      await this.authClient.signOut();
      localStorage.removeItem('authUser');
      this.isAuthenticated.next(false);
      this.router.navigate([redirect]);
    } catch (err) {
      console.error(err);
    }
  }

  getUser() {
    return JSON.parse(localStorage.getItem('authUser'));
  }
}
